import React from 'react';
// Zustand
import { useStore } from "../../zustand";
// MUI Components
import { IconButton } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
// icons
// import CameraAltIcon from '@material-ui/icons/CameraAlt';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import StopIcon from '@material-ui/icons/Stop';
// Styles
import { makeStyles } from '@material-ui/core/styles';
// Extras
// import { toPng } from 'html-to-image';

const useStyles = makeStyles(theme => ({
    hud_container: {
        background: 'linear-gradient(310deg, rgba(98,98,98,.80) 0%, rgba(35,31,32,0) 100%)',
        // background: '#0000003b',
        borderRadius: 3,
        width: 55,
        // height: 200,
        position: 'absolute',
        right: '1em',
        top: '50%'
    },
    hud_inner_content: {
        display: 'flex',
        flexDirection: 'column',
        padding: 5,
        '& button': {
            cursor: 'pointer'
        }
    },
    icon_style: {}
}));


export default function ControlsUI() {
    const classes = useStyles();
    const { turn } = useStore(state => state.clipless_animations);
    const { model_animation_status, bones_default } = useStore(state => state.model_animations);
    const actions = useStore(state => state.actions);

    // const _handleScreenShot = React.useCallback(() => {
        // alert('in the making')
        // actions.updateCanvasGL("drawing_buffer", true);
        // var node = document.getElementById('levar-scene');
        // toPng(node, { cacheBust: true, }).then((dataUrl) => {
            
            // const link = document.createElement('a')
            // link.download = 'my-image-name.png'
            // link.href = dataUrl
            // link.click()
            // actions.updateCanvasGL("drawing_buffer", false);
        // }).catch((err) => { console.log(err) })
    // }, [])

    const _handleClipless = (type, status) => {
        if(type === "turn") {
            let status_update;
            if(status === 0) status_update = 1;
            if(status === 1) status_update = 2;
            if(status === 2) status_update = 0;
            actions.setCliplessAnimation("turn", status_update);
        }   
    }

    const _handleTurnTitle = (turn) => {
        switch(turn) {
            case 0:
                return "Rotate Right"
            case 1:
                return "Rotate Left"
            case 2:
                return "Stop"
            default:
                return ""
        }
    }

    return (
        <div className={classes.hud_container}>
            <section className={classes.hud_inner_content}>
                { model_animation_status && (
                <Tooltip title={bones_default ? "Pause" : "Start Animation (1)"} placement="left">
                    <IconButton
                        color="inherit"
                        disabled={false}
                        aria-label="default_animation"
                        onClick={() => actions.setBonesAnimation(!bones_default)}
                    >
                        { bones_default ? <PauseCircleOutlineIcon className={classes.icon_style} /> : <PlayCircleOutlineIcon className={classes.icon_style} />}
                    </IconButton>
                </Tooltip>
                )}
                <Tooltip title={_handleTurnTitle(turn)} placement="left">
                    <IconButton
                        color="inherit"
                        aria-label="default_animation"
                        onClick={() => _handleClipless('turn', turn)}
                    >
                        { turn === 0 && <RotateRightIcon className={classes.icon_style} /> }
                        { turn === 1 && <RotateLeftIcon className={classes.icon_style} /> }
                        { turn === 2 && <StopIcon className={classes.icon_style} /> }
                    </IconButton>
                </Tooltip>
                {/* <Tooltip title="Screenshot" placement="left">
                    <IconButton
                        color="inherit"
                        aria-label="take screen shot"
                        onClick={_handleScreenShot}
                    >
                        <CameraAltIcon className={classes.icon_style} />
                    </IconButton>
                </Tooltip> */}
            </section>
        </div>
    )
}